import { render, staticRenderFns } from "./FaqListView.vue?vue&type=template&id=54d8222c&scoped=true&"
import script from "./FaqListView.vue?vue&type=script&lang=js&"
export * from "./FaqListView.vue?vue&type=script&lang=js&"
import style1 from "./FaqListView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8222c",
  null
  
)

export default component.exports